import { useState } from "react";
import { adminApi } from "../../api/client";

export default function BootstrapOwnerPage() {
  const [token, setToken] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await adminApi.bootstrapOwner({ token, name, email, password });
      setDone(true);
    } catch {
      setError("Не удалось создать владельца. Проверьте токен (BOOTSTRAP_OWNER_TOKEN) и повторите.");
    } finally {
      setBusy(false);
    }
  }

  if (done) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gm-bg px-4 text-center text-gm-text">
        <div>
          <h1 className="text-xl font-extrabold text-gm-success">Владелец создан ✓</h1>
          <p className="mt-2 text-gm-muted">Теперь войдите на странице /admin/login</p>
          <a href="/admin/login" className="mt-4 inline-block rounded-lg bg-gm-accent px-4 py-2 font-bold text-white">Перейти ко входу</a>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gm-bg px-4">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl border border-gm-border bg-gm-panel p-8 text-gm-text shadow-card-dark">
        <h1 className="text-lg font-extrabold">Настройка первого владельца</h1>
        <p className="mt-1 text-sm text-gm-muted">
          Работает только один раз, только с BOOTSTRAP_OWNER_TOKEN из Cloudflare Secrets. См. DEPLOYMENT.md.
        </p>
        <input value={token} onChange={(e) => setToken(e.target.value)} placeholder="Bootstrap token" required className="mt-4 w-full rounded-lg border border-gm-border bg-gm-panel2 px-3 py-2 text-sm" />
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Имя" required className="mt-2 w-full rounded-lg border border-gm-border bg-gm-panel2 px-3 py-2 text-sm" />
        <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" type="email" required className="mt-2 w-full rounded-lg border border-gm-border bg-gm-panel2 px-3 py-2 text-sm" />
        <input value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Пароль (мин. 10 символов)" type="password" required className="mt-2 w-full rounded-lg border border-gm-border bg-gm-panel2 px-3 py-2 text-sm" />
        {error && <p className="mt-2 text-xs text-gm-danger">{error}</p>}
        <button disabled={busy} className="mt-4 w-full rounded-lg bg-gm-accent py-2.5 font-bold text-white disabled:opacity-50">
          {busy ? "Создаём…" : "Создать владельца"}
        </button>
      </form>
    </div>
  );
}
